import { useState, useEffect } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { logout } from "../lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

const MARKETS = [
  { v: "ALL", label: "ALL MARKETS" },
  { v: "ASX", label: "ASX" },
  { v: "NYSE", label: "NYSE" },
  { v: "NASDAQ", label: "NASDAQ" },
  { v: "US", label: "US (NYSE+NASDAQ)" },
];

export const MarketContext = { get: () => localStorage.getItem("ie_market") || "ALL" };

export default function Layout() {
  const nav = useNavigate();
  const email = localStorage.getItem("ie_email");
  const [market, setMarket] = useState(MarketContext.get());

  useEffect(() => { localStorage.setItem("ie_market", market); window.dispatchEvent(new Event("ie:market")); }, [market]);

  const doLogout = () => { logout(); nav("/login"); };

  const linkCls = ({ isActive }) =>
    `px-4 py-2 rounded-full text-[13px] font-medium transition-colors ${
      isActive
        ? "text-[#0f1420]"
        : "text-[color:var(--text-secondary)] hover:text-[color:var(--text-primary)]"
    }`;
  const linkStyle = ({ isActive }) => (isActive ? { background: "linear-gradient(135deg, var(--violet), var(--cyan))" } : {});

  return (
    <div className="min-h-screen px-8 py-6" data-testid="app-shell">
      <header className="sticky top-6 z-20 glass-header px-5 py-3 flex items-center gap-4 mb-7">
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-xl flex items-center justify-center font-bold text-[#0f1420] text-[15px]" style={{ background: "linear-gradient(135deg, var(--violet), var(--cyan))" }}>IE</div>
          <div className="font-semibold tracking-tight text-[15px]">InsidEdge</div>
          <div className="mono text-[10px] text-[color:var(--text-tertiary)] ml-1 mt-0.5">SYD1</div>
        </div>
        <div className="flex-1 text-[12px] text-[color:var(--text-tertiary)]">
          Not financial advice — factual data condensation for personal research.
        </div>
        <nav className="flex gap-1 p-1 rounded-full bg-black/25 border border-white/[0.04]">
          <NavLink to="/" end className={linkCls} style={linkStyle} data-testid="nav-home">Home</NavLink>
          <NavLink to="/review" className={linkCls} style={linkStyle} data-testid="nav-review">Review Queue</NavLink>
          <NavLink to="/backtest" className={linkCls} style={linkStyle} data-testid="nav-backtest">Backtest</NavLink>
          <NavLink to="/settings" className={linkCls} style={linkStyle} data-testid="nav-settings">Settings</NavLink>
        </nav>
        <Select value={market} onValueChange={setMarket}>
          <SelectTrigger data-testid="market-selector-dropdown" className="mono w-44 h-9 text-xs bg-black/25 border-white/[0.06] rounded-full">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="glass rounded-2xl border-white/[0.06]">
            {MARKETS.map(m => (
              <SelectItem key={m.v} value={m.v} className="mono text-xs rounded-lg">{m.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        <div className="flex items-center gap-2 px-3 py-2 rounded-full bg-black/25 border border-white/[0.04]">
          <div className="w-6 h-6 rounded-full" style={{ background: "linear-gradient(135deg, var(--violet), var(--cyan))" }} />
          <div className="mono text-[12px] text-[color:var(--text-secondary)]" data-testid="user-email">{email}</div>
          <button onClick={doLogout} data-testid="logout-btn" className="text-[11px] text-[color:var(--text-tertiary)] hover:text-[color:var(--pink)] ml-1">Logout</button>
        </div>
      </header>
      <main><Outlet /></main>
      <footer className="mt-14 text-center text-[11px] text-[color:var(--text-tertiary)]">
        InsidEdge · Personal research tool · Not financial advice — factual data condensation for personal research.
      </footer>
    </div>
  );
}

export function useMarket() {
  const [m, setM] = useState(localStorage.getItem("ie_market") || "ALL");
  useEffect(() => {
    const h = () => setM(localStorage.getItem("ie_market") || "ALL");
    window.addEventListener("ie:market", h);
    return () => window.removeEventListener("ie:market", h);
  }, []);
  return m;
}
